export const SECTIONS_INVENTORY_MANAGEMENT = Object.freeze({
    TRANSFER: 'transfer',
    DISCOUNT: 'discount',
    ADD: 'add'
})
